<template>
  <section class="container content">
    <div class="spacing">
    <h2>About Me</h2>
    <p>
      Let's see where to start? I guess with the name. In Japanese, Kohaku means Amber, and I took a liking to it
      in college while studying Japanese. I had even gotten to the point I could speak conversationally. These
      days, however, I'm lucky if I can successfully ask
      for directions without sounding like an absolute idiot. I still enjoy the culture and hope to make
      a third trip in the near future.
    </p>
    <p>
      Professionally, I'm passionate about quality, and writing programs that provide value to others. These days
      I've been dabbling in some front-end development as you'll see here on my site as I expand the different
      projects that I've posted. You can find the snippets I've played around with on my
      <a
        href="https://github.com/ajm-kohaku"
        target="_blank"
      >GitHub</a> account.
    </p>
    <p>
      With the rest of my free time, I love playing both tabletop and online roleplaying games. I have the most
      experience in Pathfinder but have had great times playing other systems such as Cortex, Savage Worlds, d20
      Modern, and even D&D.
    </p>
    <p>
      If you'd like to get in touch, hit me up on
      <a
        href="https://twitter.com/ajm-kohaku"
        target="_blank"
      >Twitter</a> or
      <a href="https://www.linkedin.com/ambermurphy">LinkedIn</a>!
    </p>
    </div>
  </section>
</template>

<script>
export default {
  name: "About"
};
</script>

<style scoped>
a,
a:visited {
  color: hsl(168, 34%, 34%);
  text-decoration: none;
}

a:hover,
a:focus {
  color: hsl(196, 50%, 53%);
}
</style>